module.exports = __webpack_public_path__ + "img/eductorenviro_stopped.44b318c5.svg";